// Modules
import React from 'react'
import { Body, Spacing, InputPassword, Button, Flex } from '@dasa-health/alma-react'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'

// Components
import { InputStringNumber } from 'redesign/components/molecules/InputStringNumber'
import { Form } from './styles'
import { SelfServiceModal } from 'redesign/components/organisms/SelfServiceModal'

// Application
import { getFieldError } from 'redesign/utils/form'
import { Errors } from 'redesign/constants'
import { FormData, useSelfServiceCPF } from 'redesign/hooks/useSelfServiceCPF'

const CPFLoginSchema = yup
    .object({
        cpf: yup.string().required(Errors.selfService.CPF_REQUIRED),
        password: yup.string().required(Errors.selfService.PASSWORD_REQUIRED),
    })
    .required()

export const LoginSelfServiceCPF = () => {
    const {
        control,
        setError,
        handleSubmit,
        formState: { isSubmitting },
    } = useForm<FormData>({
        resolver: yupResolver(CPFLoginSchema),
        mode: 'onBlur',
        defaultValues: {
            cpf: '',
            password: '',
        },
    })

    const { handleAuthUser, changePage } = useSelfServiceCPF()
    const onSubmit = (data: FormData) => handleAuthUser({ ...data, setError })

    return (
        <Form autoComplete="off" onSubmit={handleSubmit(onSubmit)} style={{ flex: 1, display: 'flex' }}>
            <Flex flexDirection="column" justifyContent="flex-start" width="100%">
                <Body variant="lg">Para acessar, insira o CPF do paciente e a senha Nav Dasa.</Body>
                <Spacing height={24} />
                <InputStringNumber control={control} label="CPF" name="cpf" />
                <Spacing height={24} />
                <Controller
                    control={control}
                    name="password"
                    render={({ field, fieldState, formState }) => (
                        <InputPassword
                            autoComplete="off"
                            label="Senha"
                            readOnly={isSubmitting}
                            width="100%"
                            {...getFieldError(fieldState, formState)}
                            {...field}
                        />
                    )}
                />
                <Spacing height={24} />
                <Button disabled={isSubmitting} isLoading={isSubmitting}>
                    Continuar
                </Button>
                <Spacing height={24} />
                <Button onClick={changePage} type="button" variant="secondary">
                    Acessar com o protocolo
                </Button>
                <Spacing height={24} />
                <SelfServiceModal />
            </Flex>
        </Form>
    )
}
